export const API_BASE = '/api';

export const ROUTES = {
  HOME: '/',
  VIEWER: '/view/:id',
  EDITOR: '/edit/:id',
};

export const COLORS = {
  KAKAO: '#FEE500',
  BG: '#F9F9F9',
};